import { graphql, useStaticQuery } from 'gatsby';

export const usePDPConfig = () => {
	const data = useStaticQuery(graphql`
		query {
			contentstackStaticPdpConfig {
				errors {
					...Errors
				}
				info {
					url
					gatsbyImageData(quality: 90)
				}
				pricing
				quote_ctas {
					...CTA
				}
				quote_pro {
					...CTA
				}
				how_to_get_it {
					heading
					get_it_options {
						file {
							url
							gatsbyImageData(quality: 90)
						}
						heading
						subheading
					}
					enter_address
					modal {
						heading
						subheading
						job_site
					}
				}
				pro_price
				online_price
				starting_at
				custom_starting_at
				contractor_ctas {
					...CTA
				}
				lumberyard_ctas {
					...CTA
				}
				stock_ctas {
					...CTA
				}
				stock {
					product_type
					custom_starting
					heading
					ctas {
						...CTA
					}
					cta_2 {
						heading
						ctas {
							...CTA
						}
					}
				}
				tips_for_pros {
					url
					gatsbyImageData(quality: 90)
				}
				group {
					ctas {
						...CTA
					}
				}
				consultation {
					heading
					description
					ctas {
						...CTA
					}
				}
				pay_pal {
					heading
					heading_2
					trigger_text
				}
				exclusive_pricing {
					heading
					description
				}
				building_text {
					product
					heading
					subheading
					subheading2
				}
				nta_purchase_options {
					backend_name
					heading
					tooltip
					material_symbol_free
					free
					material_symbol_visit
					visit
					available
					limited
					no_showroom
					cta {
						...CTA
					}
				}
			}
		}
	`);

	return data.contentstackStaticPdpConfig;
};
